// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__7O90g","footer_content":"footer_footer_content__3c5-p","link_grid":"footer_link_grid__yt0jr"};